var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{staticClass:"create-delivery-from-temp",attrs:{"paddingMainContents":false}},[_c('Panel',{staticClass:"text-blue-800",attrs:{"title":"สร้างใบส่งสินค้าจาก API"}},[_c('CommonFormWithTempDeliveryEditor')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }